import React from 'react';
import BarChart from './charts/barChart';

interface DisruptionsByCarrierProps {
  data: {
    carriers: string[];
    cancellation: number[];
    connection: number[];
    lateDeparture: number[];
    lateArrival: number[];
    diverted: number[];
  };
}

const DisruptionsByCarrier: React.FC<DisruptionsByCarrierProps> = ({ data }) => {
  const chartData = {
    title: 'By Carrier',
    categories: data.carriers,
    series: [
      { name: 'Cancellation', data: data.cancellation },
      { name: 'Connection', data: data.connection },
      { name: 'Late Departure', data: data.lateDeparture },
      { name: 'Late Arrival', data: data.lateArrival },
      { name: 'Diverted', data: data.diverted },
    ],
  };

  return (
    <div className="row">
      <div className="col-lg-1"></div>
      <div className="col-lg-10 data-point">
        <BarChart
          reportData={chartData}
          minWidth={1000}
          height={360+(chartData.series.length*22.5)}
          bottomMargin={chartData.series.length*22.5}
        />
      </div>
      <div className="col-lg-1"></div>
    </div>
  );
};

export default DisruptionsByCarrier;